module.exports = __webpack_public_path__ + "background18.jpg?c6782b6c7f134c9d1304a8fdefbd05a9";